<template>
  <v-card elevation="0">
    <div class="pt-5 pb-5" v-if="events">
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
        </ul>
      </v-alert>
      <date-range-picker
        ref="picker"
        v-model="range"
        auto-apply
        :ranges="false"
        opens="left"
        @update="checkDates"
        :date-format="dateFormat"
      >
        <template v-slot:input="picker" style="width: 100%">
          <v-row no-gutters>
            <v-col cols="auto" class="pr-5 pt-5"
              ><v-icon color="light-blue">mdi-calendar-month</v-icon></v-col
            >
            <v-col class="py-2">
              <div class="overline">{{ $t("Checkin") }}</div>
              {{ formatDates(picker.startDate) }}</v-col
            >
            <v-col class="py-2">
              <div class="overline">{{ $t("Checkout") }}</div>
              {{ formatDates(picker.endDate) }}</v-col
            >
          </v-row>
        </template>
      </date-range-picker>
      <v-simple-table v-if="data" class="grey lighten-4 mt-5">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="subtitle-2">{{ $t("Checkin") }}</td>
              <td class="subtitle-2 font-weight-bold text-right" width="140px">
                {{ formatDates(range.startDate) }}
              </td>
            </tr>
            <tr>
              <td class="subtitle-2">{{ $t("Checkout") }}</td>
              <td class="subtitle-2 font-weight-bold text-right" width="140px">
                {{ formatDates(range.endDate) }}
              </td>
            </tr>
            <tr>
              <td class="subtitle-2 font-weight-bold">{{ $t("Total") }}</td>
              <td class="subtitle-2 font-weight-bold text-right" width="140px">
                <span
                  v-if="data.days >= 7"
                  class="text-decoration-line-through grey--text"
                >
                  {{ data.currency_code }} {{ data.mimicPrice }}
                </span>
                <br />
                {{ data.currency_code }} {{ data.actualPrice }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div v-if="data">
      <v-alert
        border="bottom"
        colored-border
        type="warning"
        elevation="1"
        v-if="data.days >= 7"
      >
        {{ $t("LP1") }}
        <strong
          >{{ data.currency_code }}
          {{ (data.mimicPrice - data.actualPrice).toFixed(2) }}</strong
        >
        {{ $t("LP2") }}
      </v-alert>
    </div>
    <v-card-actions>
      <v-btn
        v-if="data && $store.getters.isLoggedIn"
        color="light-blue"
        dark
        block
        @click="bookNow"
      >
        {{ $t("BookNow") }}
      </v-btn>
      <v-btn
        v-if="data && !$store.getters.isLoggedIn"
        color="light-blue"
        dark
        block
        @click="openLoginDialog"
      >
        {{ $t("BookNow") }}
      </v-btn>
    </v-card-actions>
    <!-- Please stand by dialog -->
    <v-dialog v-model="waitDialog" persistent width="50%">
      <v-card color="light-blue" dark>
        <v-card-text class="pt-5">
          <div class="subtitle-1 text-center pb-3">Please stand by</div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Please stand by dialog -->
  </v-card>
</template>

<script>
import BookingService from "@/services/BookingService";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { format } from "date-fns";
import isFuture from "date-fns/isFuture";
import addDays from "date-fns/addDays";

export default {
  name: "PriceSectionComponent",
  components: { DateRangePicker },
  data() {
    return {
      format,
      isFuture,
      addDays,
      range: {
        startDate: "",
        endDate: ""
      },
      waitDialog: false,
      error: null,
      data: null,
      id: this.$route.params.id,
      dates: null,
      currency_code: this.$store.state.user.prefered_currency,
      guestData: {
        guestRegister: false
      },
      events: "",
      bookedDates: []
    };
  },
  created: function() {
    BookingService.getOnlyAvailable({
      property_id: this.id
    })
      .then(result => {
        if (result.data) {
          this.events = result.data.map(e => e.date_string);
        }
      })
      .catch(err => {
        this.error = err.response.data.errors;
      });
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = !this.events.includes(
          this.format(new Date(date), "yyyy-MM-dd")
        );
      }
      return classes;
    },
    formatDates(val) {
      if (val) return this.format(new Date(val), "MM-dd-yyyy");
      else return "MM-DD-YYYY";
    },
    checkDates(val) {
      this.data = "";
      this.error = null;
      let isSameDate = val.startDate.getTime() === val.endDate.getTime();
      if (isSameDate) {
        this.error = [{ msg: "Please select aleast one night" }];
      } else {
        // Google Tag Manager
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "checkAvailability",
          propertyId: this.id,
          startDate: this.format(new Date(val.startDate), "yyyy-MM-dd"),
          endDate: this.format(new Date(val.endDate), "yyyy-MM-dd")
        });
        // Google Tag Manager
        this.waitDialog = true;
        BookingService.checkBooking({
          start: this.format(new Date(val.startDate), "yyyy-MM-dd"),
          end: this.format(new Date(val.endDate), "yyyy-MM-dd"),
          property_id: this.id,
          prefered_currency: this.currency_code
        })
          .then(result => {
            this.data = result.data;
            this.waitDialog = false;
          })
          .catch(err => {
            this.error = err.response.data.errors;
            this.waitDialog = false;
          });
      }
    },
    openLoginDialog() {
      let reserveData = {
        dates: [
          this.format(new Date(this.range.startDate), "yyyy-MM-dd"),
          this.format(new Date(this.range.endDate), "yyyy-MM-dd")
        ],
        property_id: this.id
      };
      this.$store.dispatch("setReserveQuery", reserveData);
      this.$router.push("/login?redirect=/review-booking");
    },
    bookNow() {
      let reserveData = {
        dates: [
          this.format(new Date(this.range.startDate), "yyyy-MM-dd"),
          this.format(new Date(this.range.endDate), "yyyy-MM-dd")
        ],
        property_id: this.id
      };
      this.$store.dispatch("setReserveQuery", reserveData);
      this.$router.push({ name: "ReviewBooking" });
    }
  }
};
</script>

<style>
.form-control.reportrange-text {
  border-radius: 10px;
  padding: 10px 20px;
  border: 1px solid #000;
}
.vue-daterange-picker {
  width: 100%;
}
.daterangepicker td.in-range {
  background-color: #80c0ff !important;
}
.daterangepicker td.in-range.active {
  background-color: #004d99 !important;
}
</style>
